// eslint-disable-next-line no-unused-vars
const days = time => Math.floor(time / (1000 * 60 * 60 * 24));

const hours = time => Math.floor((time / (1000 * 60 * 60)) % 24);

const minutes = time => Math.floor((time / 1000 / 60) % 60);

const seconds = time => Math.floor((time / 1000) % 60);

const generateDaysText = (time) => {
  const _days = days(time);
  return _days > 0 ? `${_days}:` : '';
};

const genereteHoursText = (time) => {
  const _hours = hours(time);
  const _paddedHours = `${_hours}`.padStart(2, '0');
  return _hours > 0 ? `${_paddedHours}:` : '';
};

const genereteMinutesText = (time) => {
  const _minutes = minutes(time);
  return `${_minutes}`.padStart(2, '0');
};

const genereteSecondsText = (time) => {
  const _seconds = seconds(time);
  return `${_seconds}`.padStart(2, '0');
};
/**
 * Generate TimeOut text for negotiations
 * @param {number} time
 */
export const genereteTimeText = time => `${generateDaysText(time)}${genereteHoursText(time)}${genereteMinutesText(time)}:${genereteSecondsText(time)}`;
